import { type UseQueryResult, useQuery } from 'react-query';
import {
  OptionExerciseService,
  // eslint-disable-next-line camelcase
  type PagedResultDto_AdminExerciseDto,
} from '../../services/wealthlane-award-services';
import { type TableParamsType } from '../../types/common';
import { useEffect } from 'react';
import { isEqual } from 'lodash';
import InitialValuesForm from '../../constants/initialValues';

const useGetOptionExercisedList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType,
  showExercisedListOnly: boolean
): UseQueryResult<
  // eslint-disable-next-line camelcase
  PagedResultDto_AdminExerciseDto | undefined,
  unknown
> => {
  const {
    settlementTypeIds,
    recordTypes,
    createdFromDate,
    createdToDate,
    filter,
    sorting,
    skipCount,
    maxResultCount,
    optionGrantName,
    _force,
  } = tableInfo;
  const optionExercisedList = useQuery(
    [
      'getOptionExercisedList',
      settlementTypeIds,
      recordTypes,
      createdFromDate,
      filter,
      createdToDate,
      sorting,
      skipCount,
      maxResultCount,
      optionGrantName,
      _force,
    ],
    async () => {
      return await handleRequest(
        OptionExerciseService.getApiAwardApiAppOptionExerciseOptionExercisedList(
          settlementTypeIds,
          optionGrantName,
          recordTypes,
          createdFromDate,
          createdToDate,
          showExercisedListOnly,
          undefined,
          filter,
          sorting,
          skipCount,
          maxResultCount
        )
      );
    }
  );

  return optionExercisedList;
};

export default useGetOptionExercisedList;
